import React, { useContext, useEffect } from "react";

import { ITINERARY } from "../constants/editor";
import { EditorContext } from "../containers/editor/EditorLayout";

const useItineraryEvent = () => {
  let { metadata, setShowPricingTableImageCarousel } = useContext(EditorContext);

  const handleImageClick = event => {
    let items = [];
    let startingImageIndex =
      event.target.classList.contains("counter") || event.target.classList.contains("counter-box")
        ? 4
        : event.target.closest(".itinerary-image")?.getAttribute("data-image-number");

    if (startingImageIndex === undefined) return;

    let dataSrc = event.target.closest(".image-list").getAttribute("data-image-urls");
    let imageArray = dataSrc.split(",");
    imageArray.forEach((img, index) => {
      let newObj = {
        src: img,
        altText: `${index + 1}/${imageArray?.length}`,
        active: parseInt(startingImageIndex) === index ? true : false,
      };
      items.push(newObj);
    });
    setShowPricingTableImageCarousel(items);
  };

  useEffect(() => {
    if (metadata.activeWidgetType[0] !== ITINERARY || document.querySelector(".itinerary-modal")) return;

    const imageElements = document.querySelectorAll(".image-list");
    imageElements.forEach(el => {
      el.addEventListener("click", handleImageClick);
    });

    // Cleanup on unmount
    return () => {
      imageElements.forEach(el => {
        el.removeEventListener("click", handleImageClick);
      });
    };
  });
};

export default useItineraryEvent;
